import { createContext, useContext } from "react"
export type AuthContent = {
    token: string,
    onLogin: () => void,
    onLogout: () => void,
}
export const AuthContext = createContext<AuthContent>({
    token: '', // set a default value
    onLogin: () => {},
    onLogout: () => {},
})
export const useAuth = () => useContext(AuthContext)
